module.exports = __webpack_public_path__ + "static/media/info_block_1.b06fdda0.jpg";